import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { Article, Category } from '@twisto/api-cms'

import { CategoryPaper } from '../category-paper'
import { ContentListLink } from '../subcategory-list/subcategory-content-list/'

import * as styles from './article-list.styles'

type Props = {
  articles: Article[]
  categories?: Category[]
  categoryName: string
}

export const ArticleList = ({ articles, categoryName, categories }: Props) => (
  <CategoryPaper>
    <Typography
      color="textPrimary"
      component="h1"
      fontWeight="heavy"
      variant="h2"
    >
      {categoryName}
    </Typography>
    <ul css={styles.list}>
      {categories?.map((category) => (
        <ContentListLink
          key={category.path}
          fontWeight="medium"
          text={category.name}
          to={category.path}
        />
      ))}
      {articles
        .filter((article) => article.publishedAt)
        .map((article) => (
          <ContentListLink
            key={article.id}
            text={article.headline}
            to={article.path}
          />
        ))}
    </ul>
  </CategoryPaper>
)
